module.exports = __webpack_public_path__ + "static/img/1-1.f2007c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/1-1.png
// module id = sewN
// module chunks = 0